import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar',
  template: '',
  styleUrls: []
})
export class NavbarComponent { }


// VIEJA FUNCION DEL COMPONETE navbar.
// import { Component, OnInit } from '@angular/core';
// import { Subject } from 'rxjs';
// import { Store } from '@ngrx/store';
// import { AppState } from 'src/app/store/app.reducer';
// import { MenuVisibleAction, MenuHiddenAction } from '../../../store/actions/Componentes/menu.actions';
// import { Router } from '@angular/router';

// @Component({
//   selector: 'app-navbar',
//   templateUrl: './navbar.component.html',
//   styleUrls: ['./navbar.component.css']
// })
// export class NavbarComponent implements OnInit {
//   MenuActivo = true;
//   private subject = new Subject<boolean>();

//   constructor(
//     private store: Store<AppState>,
//     private router: Router
//     ) { }

//   ngOnInit() {
//     if (document.documentElement.clientWidth < 600) {
//       this.MenuActivo = false;
//       this.store.dispatch(new MenuHiddenAction());
//     }
    
//     if(location.pathname.includes('Print'))
//     {
//       document.querySelector('.navbarMain').classList.add('d-none')
//       console.log(location.pathname, location.pathname.includes('Print'));
//     }
//   }

//   AccionMenu() {
//     this.MenuActivo = !this.MenuActivo;
//     if (this.MenuActivo) {
//       this.store.dispatch(new MenuVisibleAction());
//     } else {
//       this.store.dispatch(new MenuHiddenAction());
//     }
//   }
//   singOut() {
//     localStorage.removeItem('token');
//     localStorage.removeItem('Cuenta');
//     window.location.reload();
//   }
// }